/**
 * Chart 域类型权威定义。
 *
 * ## 为何 ChartType 放在 types.ts（而非 constants.ts）
 *
 * `ChartType` 是 **type-defining const**：定义 chart 域「合法 chart_type 有哪些」，并派生 `TChartType`。
 * 全模块用 `TChartType` 做参数/比较约束；`Object.values(ChartType)` 也依赖这份集合。
 *
 * 与 constants.ts 的分工（dbl-typescript §2.1.4）：
 * - types.ts：合法取值集合 + 类型边界（「是什么」）
 * - constants.ts：基于类型的轻量映射/默认值（「怎么映射」，不定义新类型边界）
 *
 */

/**
 * 图表类型：前端组件、配置面板与保存协议共用的合法取值集合。
 * 新增成员时须同步补全 constants.ts 中的 `ConfigChartType` 映射（Record 全覆盖约束）。
 */
export const ChartType = {
  Table: 'Table',
  Pie: 'PieChart',
  Bar: 'BarChart',
  StackBar: 'StackBarChart',
  Line: 'LineChart',
  EventLine: 'EventLineChart',
  BigNumber: 'BigNumberChart',
  Trend: 'TrendChart',
  MixedChart: 'MixedChart',
  DimNumberTrend: 'dim_trend',
  Map: 'Map',
  WordCloud: 'WordCloud',
  HorizontalBarChart: 'HorizontalBarChart',
  PercentStackBar: 'PercentStackBarChart',
  PercentLine: 'PercentLineChart',
} as const;

export type TChartType = (typeof ChartType)[keyof typeof ChartType];
